import * as React from 'react';

const MusicNoteFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="music-note-fill_svg__eds-icon--music-note_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="music-note-fill_svg__eds-icon--music-note_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 2L8 5.5v11.3c-.5-.5-1.2-.8-2-.8-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3V9.5l11-3v7.2c-.5-.5-1.2-.8-2-.8-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3V2z"
        />
    </svg>
);

MusicNoteFillSvg.displayName = 'MusicNoteFillSvg';
export default MusicNoteFillSvg;
